import React from 'react';
type BrandGlyphProps = {
  className?: string;
};

/**
 * Simplified interpretation of the CoPro infinity + rising arrow mark,
 * used sparingly as a decorative brand element.
 */
export function BrandGlyph({
  className = ''
}: BrandGlyphProps) {
  return <svg viewBox="0 0 220 120" fill="none" aria-hidden="true" className={className} data-id="element-29" data-mp="3sj9101tpjyww">
      <path d="M22 78c0-19 13-32 29-32s26 12 34 26c9 15 18 26 33 26 16 0 29-13 29-32s-13-32-29-32-25 11-34 26c-8 14-18 26-33 26-16 0-29-13-29-32Z" stroke="currentColor" strokeWidth="9" strokeLinecap="round" data-id="element-30" data-mp="2zwodjcgcs6ym" />
      <path d="M140 62 196 16" stroke="currentColor" strokeWidth="9" strokeLinecap="round" data-id="element-31" data-mp="38wkust0ey3jn" />
      <path d="M168 12h36v36l-13-13-10 4-7-11 7-6-13-10Z" fill="currentColor" data-id="element-32" data-mp="3dq79eqq50hi3" />
    </svg>;
}